import { createFileRoute, Navigate } from '@tanstack/react-router';
import { LoginForm } from '@/components/features/auth/LoginForm';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { useAuth } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/login')({
  component: LoginComponent,
});

function LoginComponent() {
  const { isAuthenticated, isAdmin } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={isAdmin ? ROUTES.ADMIN.ROOT : ROUTES.DEPOSITS} />;
  }

    return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
}
